import { getLayout } from "@/services/services";

// export const fetch_GA_ID = async () => {
//   const hostNameUrl = window.location.host;
//   const layoutFromApi = await getLayout(hostNameUrl);
//   if (layoutFromApi && layoutFromApi.layout && layoutFromApi.layout.config) {
//     return layoutFromApi.layout.config.measurementId || null;
//   }
//   return null;
// }

// lib/ga.js
export const GA_TRACKING_ID = "G-BN4T31MMBQ"; // Thay bằng mã thực tế

// Gửi pageview đến GA

export const pageview = (url) => {
  window.gtag("config", GA_TRACKING_ID, {
    page_path: url,
  });
};

// Gửi sự kiện tùy chỉnh (nếu cần)
export const event = ({ action, category, label, value }) => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
